module.exports = __webpack_public_path__ + "static/media/logoText.bc4e4f39.svg";